import axios from "axios";
import { urls } from "../../utils/AppManager";
import { getAuthHeaders } from "../../utils/headers";

export const getLeadDistributionRatio = async (
  payload,
  fromDate,
  toDate,
) => {
  const body = {
    pageNumber: payload?.currentPage,
    pageSize: payload?.recordsPerPage,
    fromDate,
    toDate,
    searchQuery: payload?.searchQuery || "",
  };

  const url = `${process.env.REACT_APP_API_BASE_URL}${urls.getLeadDistributionRatio}`;

  const headers = {
    ...getAuthHeaders(),
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(url, body, { headers });
    return response?.data;
  } catch (error) {
    console.error("Error fetching lead distribution ratio", error);
    throw error;
  }
};

export const updateLeadDistributionRatio = async (payload) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}${urls.updateLeadDistributionRatio}`;

  const headers = {
    ...getAuthHeaders(),
    "Content-Type": "application/json",
  };

  const body = {
    id: payload?.id,
    ...(payload?.maxLimit != null && { maxLimit: payload?.maxLimit }),
    ...(payload?.ratio != null && { ratio: payload?.ratio }),
  };

  try {
    const response = await axios.put(url, body, { headers });
    return response?.data;
  } catch (error) {
    console.error("Error updating lead distribution ratio", error);
    throw error;
  }
};